<section class="py-16 bg-dark">
  <div class="container mx-auto px-4">
    <h2 class="text-3xl md:text-4xl font-bold mb-12 text-center text-light text-shadow-glow">Veelgestelde Vragen</h2>
    
    <div class="max-w-3xl mx-auto">
      <div *ngFor="let faq of featuredFaqs; let i = index" class="mb-4">
        <div class="bg-dark-light rounded-lg shadow-md overflow-hidden border border-primary/20">
          <button
            (click)="toggle(i)"
            class="w-full px-6 py-4 text-left flex justify-between items-center hover:bg-gray-800 transition-colors"
          >
            <span class="font-semibold text-lg text-light">{{ faq.question }}</span>
            <span class="text-primary text-xl">{{ expandedIndex === i ? '−' : '+' }}</span>
          </button>
          <div *ngIf="expandedIndex === i" class="px-6 py-4 bg-dark border-t border-primary/20">
            <p class="text-gray-300">{{ faq.answer }}</p>
          </div>
        </div>
      </div>

      <div class="text-center mt-8">
        <button 
          (click)="goToFaqPage()"
          class="bg-primary text-light px-8 py-3 rounded-lg font-semibold hover:bg-pink-700 transition-all duration-300 shadow-glow transform hover:scale-105"
        >
          Bekijk Alle Veelgestelde Vragen
        </button>
      </div>
    </div>
  </div>
</section>

